export default __webpack_public_path__ + "static/media/quiz-q10.8af11c1d.png";